export const FONT_ID = {
  misanslatin: 0,
  misansw: 1,
  misanstc: 2,
  misans: 3,
  misansf: 4,
  notosans: 5
};
export const FONT_Weight = {
  bold: 0,
  demibold: 1,
  extralight: 2,
  heavy: 3,
  light: 4,
  medium: 5,
  normal: 6,
  regular: 7,
  semibold: 8,
  thin: 9
};

export type FontIdKey = keyof typeof FONT_ID;
export type FontWeightKey = keyof typeof FONT_Weight;

export const LAYOUT = 0x00,
  STRING = 0x01,
  IMG = 0x02,
  IMG_ARRAY = 0x03,
  SPRITE = 0x04,
  FILE = 0x05,
  TRANSLATION = 0x06,
  DATA = 0x07,
  SLOT = 0x08,
  WIDGET = 0x09,
  CONDITION = 0x0a,
  ANIMATION = 0x0b,
  TOTAL_COUNT = 12; //每个类型设置的id

export const app_id = [
  'pressure@0x0003',
  'breath@0x0004',
  'heartrate@0x0005',
  'sleep@0x000C',
  'SpO2@0x000E',
  'sport@0x000F',
  'activities@0x0013',
  'media@0x0015',
  'settings@0x0016',
  'battery@0x0016',
  'compass@0x0018',
  'flashlight@0x001A',
  'calendar@0x001B',
  'remoteCamera@0x001C',
  'sportsRecord@0x001D',
  'alipay@0x001E',
  'womenHealth@0x001F',
  'chronograph@0x0020',
  'weather@0x0021',
  'phone@0x0023',
  'wxpay@0x0025',
  'timer@0x0026',
  'findPhone@0x0027',
  'alarm@0x0028',
  'recorder@0x0029',
  'barometer@0x002A',
  'nfcCard@0x002B',
  'voiceAssistant@0x002D',
  'contact@0x002E',
  'sportsCourse@0x002F',
  'temperature@0x0030',
  'share@0x0031',
  'bloodPressure@0x0034',
  'ECG@0x0035',
  'vitalityValue@0x0036',
  'jsApplication@0x0037',
  'luaApplication@0x0038',
  'trainingStatus@0x0039',
  'todo@0x003C',
  'miJia@0x003F',
  'glucose@0x0042',
  'interconnect@0x0043',
  'sms@0x0046',
  'worldclock@0x003B',
  'perpetualcalendar@0x0045',
  'amap@0x0047',
  'intercom@0x004E',
  'navigation@0x0048',
  'research@0x0051',
  'healthScan@0x0057',
  'weightManagement@0x005D',
  'uvSensor@0x005E',
  'healthSummary@0x005F',
  'wechat@0X00FF'
];
export const appWidget_id = [
  'heartRateRectangleDark@0x1092', // = WidgetSubType_HEART_RATE_DARK_RECT_SPLASH
  'WidgetSubType_HEART_RATE_DARK_RECT_SPLASH@0x1092',
  'heartRateRectangleLight@0x1192', // = WidgetSubType_HEART_RATE_LIGHT_RECT_SPLASH
  'WidgetSubType_HEART_RATE_LIGHT_RECT_SPLASH@0x1192',
  'fitnessRectangleLightStand@0x0d94',
  'WidgetSubType_FITNESS_LIGHT_RECT_STAND@0x0d94',
  'fitnessRectangleDarkStand@0x0c94', // = WidgetSubType_FITNESS_DARK_RECT_STAND
  'WidgetSubType_FITNESS_DARK_RECT_STAND@0x0c94',
  'weatherRectangleDarkHourly@0x2893', // = WidgetSubType_WEATHER_DARK_RECT_HOURLY
  'WidgetSubType_WEATHER_DARK_RECT_HOURLY@0x2893',
  'weatherRectangleLightHourly@0x2993', // = WidgetSubType_WEATHER_LIGHT_RECT_HOURLY
  'WidgetSubType_WEATHER_LIGHT_RECT_HOURLY@0x2993',
  'weatherRectangleDarkSun@0x2894', // = WidgetSubType_WEATHER_DARK_RECT_SUN
  'WidgetSubType_WEATHER_DARK_RECT_SUN@0x2894',
  'weatherRectangleLightSun@0x2994', // = WidgetSubType_WEATHER_LIGHT_RECT_SUN
  'WidgetSubType_WEATHER_LIGHT_RECT_SUN@0x2994',
  'calenderRectangleDarkNext@0x4891', // = WidgetSubType_CALENDAR_DARK_RECT_NEXT
  'WidgetSubType_CALENDAR_DARK_RECT_NEXT@0x4891',
  'calenderRectangleLightNext@0x4991', // = WidgetSubType_CALENDAR_LIGHT_RECT_NEXT
  'WidgetSubType_CALENDAR_LIGHT_RECT_NEXT@0x4991',
  'fitnessRectangleDarkActivity@0x0c95', // = WidgetSubType_FITNESS_DARK_RECT_ACTIVITY
  'WidgetSubType_FITNESS_DARK_RECT_ACTIVITY@0x0c95',
  'fitnessRectangleDarkStep@0x0c92', // = WidgetSubType_FITNESS_DARK_RECT_STEP
  'WidgetSubType_FITNESS_DARK_RECT_STEP@0x0c92',
  'fitnessRectangleDarkCalorie@0x0c93', // = WidgetSubType_FITNESS_DARK_RECT_CALORIE
  'WidgetSubType_FITNESS_DARK_RECT_CALORIE@0x0c93',
  // 'WidgetSubType_HEART_RATE_DARK_RECT_SPLASH@0xc96',
  'WidgetSubType_SLEEP_DARK_RECT_LONG@0x2092',
  'WidgetSubType_FITNESS_DARK_RECT_VITALITY@0xc91',
  // 新增
  'WidgetSubType_FITNESS_DARK_SQUARE_VITALITY@0x0c81',
  'WidgetSubType_SLEEP_DARK_RECT_RESULT@0x2091',
  'WidgetSubType_SLEEP_DARK_RECT_STRUCTURE@0x2093',
  'WidgetSubType_WEATHER_DARK_RECT_WEEK@0x2892',
  'WidgetSubType_WEATHER_DARK_RECT_HOURLY_2@0x2895',
  'WidgetSubType_WEATHER_DARK_RECT_HOURLY_3@0x2896',
  'WidgetSubType_WEATHER_LIGHT_RECT_WEEK@0x2992',
  'WidgetSubType_BLOOD_OXYGEN_DARK_RECT_SPLASH@0x1c92',
  'WidgetSubType_PRESSURE_DARK_RECT_LINE@0x1893',
  'WidgetSubType_PRESSURE_DARK_RECT_SPLASH@0x1892',
  'WidgetSubType_CALENDAR_LIGHT_SQUARE_NEXT@0x4981',
  'WidgetSubType_CALENDAR_DARK_CIRCLE_DAY@0x48a2',
  'WidgetSubType_TIME_KEEPING_DARK_SQUARE_ENTRY@0x4481',
  'WidgetSubType_TRAINING_STATUS_DARK_SQUARE@0x7c91',
  'WidgetSubType_WEEKLY_LOAD_DARK_SQUARE@0x7c92',
  'WidgetSubType_COMPASS_DARK_SQUARE@0x7891',
  'WidgetSubType_ALARM_DARK_SQUARE@0x6491',
  'WidgetSubType_MUSIC_DARK_SQUARE@0x3891'
];
export const enumGroupType = [
  'general',
  'activityStatistics',
  'step',
  'calorie',
  'stand',
  'intensity',
  'heartRate',
  'oxygenSaturation',
  'pressure',
  'base',
  'cardBag',
  'weather',
  'tools',
  'wechat',
  'alipayPaymentCode',
  'sportHealth',
  'sport',
  'bloodPressure',
  'ECG',
  'vitalityValue',
  'jsApplication',
  'luaApplication',
  'trainingStatus',
  'none'
];
